module.exports = __webpack_public_path__ + "media/images/bg/mosaic/oyakata-7c37361950e6632880d2a7073e181ec8.svg";